import { render, staticRenderFns } from "./UserFormView.vue?vue&type=template&id=1b2ce54b&scoped=true&"
import script from "./UserFormView.vue?vue&type=script&lang=js&"
export * from "./UserFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_pcivgqzi2ggw3w32ihxlyfliwi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ce54b",
  null
  
)

export default component.exports